(function () {
  function initPSAGrading(root) {
    if (!root || root.dataset.pbInitialized === 'true') return;
    root.dataset.pbInitialized = 'true';

    root.querySelectorAll('[data-pb-faq-button]').forEach(function (button) {
      button.addEventListener('click', function () {
        var item = button.closest('.pb-psa-faq__item');
        var open = item.classList.toggle('is-open');
        button.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });

    var sticky = root.querySelector('[data-pb-mobile-sticky]');
    var hero = root.querySelector('[data-pb-hero]');
    if (sticky && hero && 'IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          sticky.classList.toggle('is-visible', !entry.isIntersecting);
        });
      }, { threshold: 0.08 });
      observer.observe(hero);
    }
  }

  document.querySelectorAll('.pb-psa[data-pb-page-root]').forEach(initPSAGrading);

  document.addEventListener('shopify:section:load', function (event) {
    var nearest = event.target.closest('.pb-psa[data-pb-page-root]') || event.target.querySelector('.pb-psa[data-pb-page-root]');
    if (nearest) initPSAGrading(nearest);
  });
})();
